import { Action, createReducer, on } from '@ngrx/store';
import {
  fetchHomeViewConfigSuccess,
  setHomeFilterString,
  setHomeObjectsLifeCycle,
  setHomeSortingDirection,
  setHomeSortingField,
  setHomeTab,
  toggleHomeViewConfigOption,
} from '../actions/home.actions';

import { PropertyViewConfig } from 'src/app/core/services/feed-settings.service';
import { SortDirection } from '../constants';
import { loginSuccess } from '../actions/auth.actions';
import { produce } from 'immer';

export interface HomeState {
  tab: 'recent' | 'active' | 'archived' | 'deleted';
  filterString?: string;
  sortField?: string;
  sortDirection?: SortDirection;
  viewOptions?: PropertyViewConfig[];
}

export const initialState: HomeState = {
  tab: 'active',
  filterString: '',
  sortField: 'title',
  sortDirection: 'asc',
  viewOptions: [],
};

const _homeReducer = createReducer(
  initialState,
  on(setHomeFilterString, (state, { filterString }) => {
    return {
      ...state,
      filterString,
    };
  }),
  on(setHomeSortingField, (state, { sortingField }) => {
    return {
      ...state,
      sortField: sortingField,
    };
  }),

  on(setHomeSortingDirection, (state, { sortingDirection }) => {
    return {
      ...state,
      sortDirection: sortingDirection,
    };
  }),
  on(setHomeTab, (state, { tab }) => {
    return {
      ...state,
      tab,
    };
  }),

  on(loginSuccess, (state, { response }) => {
    // Safely access nested properties and provide fallback values for undefined fields
    const user = response.user;
    const objectManagerHome = user?.context_settings?.['object_manager_home'];

    return {
      ...state,
      sortField: objectManagerHome?.sortingField ?? 'title', // fallback to a default if sortingField is missing
      sortDirection: objectManagerHome?.sortingDirection ?? 'asc', // fallback to 'asc' if sortingDirection is missing
    };
  }),

  on(fetchHomeViewConfigSuccess, (state, { defaultHomeConfig, homeConfig }) => {
    return {
      ...state,
      viewOptions: defaultHomeConfig.map((option) => {
        const existingOption = homeConfig.find(
          (v) => v.propertyUri === option.propertyUri,
        );

        return {
          ...option,
          selected: option.selected || existingOption?.selected || false,
        };
      }),
    };
  }),

  on(
    toggleHomeViewConfigOption,
    produce((draft, { optionName }) => {
      const option = draft.viewOptions.find((opt) => opt.label === optionName);

      if (!option) return;

      option.selected = !option.selected;
    }),
  ),
);

export function homeReducer(state: HomeState, action: Action) {
  return _homeReducer(state, action);
}
